import { FaCheckCircle } from 'react-icons/fa';
import { formatDate } from '../../helper/helper';
import { headerImageUrl, withLegacyImageFallback } from '../../helper/mediaUrl';
import { journalPublishUrl } from '../../helper/journalUrl';

const AuthorList = ({ items }) => {
    if (!items) return '-';
    return (
        <ul className="space-y-0.5">
            {items.split(',').map((item, index) => (
                <li key={index}>
                    {item.trim()}
                    <sup className="text-muted">({index + 1})</sup>
                </li>
            ))}
        </ul>
    );
};

const Row = ({ label, value, children }) => (
    <div className="flex gap-4 border-b border-hairline pb-3 dark:border-white/10">
        <dt className="w-32 shrink-0 font-medium text-muted">{label}</dt>
        <dd className="min-w-0 flex-1 text-ink dark:text-white">
            {children || value || '-'}
        </dd>
    </div>
);

const VerifyResult = ({ data, className = '' }) => {
    if (!data) return null;

    return (
        <div className={`card overflow-hidden ${className}`.trim()}>
            {data.headers ? (
                <img
                    src={headerImageUrl(data.headers)}
                    onError={(e) => withLegacyImageFallback(e, data.headers)}
                    alt=""
                    className="w-full object-cover"
                />
            ) : null}

            <div className="card-body">
                <div className="mb-6 flex flex-col items-center text-center">
                    <FaCheckCircle className="text-5xl text-green-600 dark:text-green-400" />
                    <p className="mt-2 text-sm font-medium uppercase tracking-wider text-green-600 dark:text-green-400">
                        Verified
                    </p>
                </div>

                <h2 className="text-center text-xl font-medium text-ink dark:text-white">
                    {data.journal_name}
                </h2>

                <dl className="mt-6 space-y-3 text-sm">
                    <Row label="ID" value={data.submitID} />
                    <Row label="Author">
                        <AuthorList items={data.author} />
                    </Row>
                    <Row label="Affiliate">
                        <AuthorList items={data.affiliate} />
                    </Row>
                    <Row label="Title" value={data.title} />
                    <Row label="Date" value={formatDate(data.date)} />
                    <Row label="Vol." value={data.volume} />
                    <Row label="Issue" value={data.issue} />
                    {data.month ? <Row label="Month" value={data.month} /> : null}
                    {data.year ? <Row label="Year" value={data.year} /> : null}
                    {data.journal_publish ? (
                        <Row label="Journal publish">
                            <a
                                href={journalPublishUrl(data.journal_publish)}
                                className="text-link break-all"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {data.journal_publish}
                            </a>
                        </Row>
                    ) : null}
                </dl>
            </div>
        </div>
    );
};

export default VerifyResult;
